import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { Observable } from 'rxjs';
import {
	UpgradeRequest,
	UpgradeResponse
} from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

export interface IUpgradeSubscriptionService {
	upgrade(request: UpgradeRequest): Observable<UpgradeResponse>;
}

@Injectable({ providedIn: 'root' })
export class UpgradeSubscriptionService implements IUpgradeSubscriptionService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/upgrade`;

	constructor(private http: HttpClient) {}

	upgrade(request: UpgradeRequest): Observable<UpgradeResponse> {
		return this.http.post<UpgradeResponse>(this.url, request, {
			headers: idempotencyHeaders()
		});
	}
}
